// import { useEffect, useLayoutEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// // Scrolls to top on every route change. Uses layout effect for reliability.
// export default function ScrollToTop({ behavior = 'auto' }) {
//   const { pathname, search } = useLocation();

//   // Disable browser's native scroll restoration so we control it.
//   useEffect(() => {
//     if ('scrollRestoration' in window.history) {
//       const prev = window.history.scrollRestoration;
//       window.history.scrollRestoration = 'manual';
//       return () => {
//         window.history.scrollRestoration = prev;
//       };
//     }
//   }, []);

//   // Scroll synchronously after DOM updates but before paint
//   useLayoutEffect(() => {
//     try {
//       window.scrollTo({ top: 0, left: 0, behavior });
//     } catch (_) {
//       // Fallback for older browsers
//       window.scrollTo(0, 0);
//     }
//     // Extra fallbacks for various scroll roots
//     if (document.documentElement) document.documentElement.scrollTop = 0;
//     if (document.body) document.body.scrollTop = 0;
//   }, [pathname, search, behavior]);

//   return null;
// }



import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Smoothly scrolls to top on every route change.
export default function ScrollToTop({ behavior = 'smooth' }) {
  const { pathname, search } = useLocation();

  // Disable native scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => {
        window.history.scrollRestoration = prev;
      };
    }
  }, []);

  // Scroll smoothly after DOM updates
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, search, behavior]);

  return null;
}
